import { Star } from "lucide-react";

const WORDS = [
  "Sing", "Learn", "Play", "Grow", "Faith", "Kindness", "Hope",
  "Bedtime Lullabies", "Parent Approved", "Bible Stories",
];

const Ribbon = () => (
  <div className="flex shrink-0 items-center">
    {WORDS.map((w) => (
      <span key={w} className="flex items-center">
        <span className="whitespace-nowrap px-6 font-display text-2xl font-medium text-slate-800 sm:text-3xl">
          {w}
        </span>
        <Star className="h-5 w-5 shrink-0 fill-[#FFFDF6] text-[#FFFDF6]" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <section
    className="relative -rotate-1 border-y-4 border-slate-900 bg-[#FFC107] py-5"
    data-testid="editorial-marquee"
    aria-label="Brand values ribbon"
  >
    <div className="animate-marquee flex w-max">
      <Ribbon />
      <Ribbon />
    </div>
  </section>
);

export default Marquee;
